<template>
  <v-card class="card">
    <v-card-title class="d-flex justify-space-between pb-0 pt-1">
      <span class="a-title-xl">{{ title }} </span>
      <div class="alarm-items">
        <span v-if="!isMobile" class="a-text a-thin mr-1"
          >Filtro por prioridade</span
        >
        <v-switch
          v-if="!isMobile"
          v-model="severetyMode"
          color="primaryLight"
        />
        <v-btn @click="$emit('close')" icon><v-icon>close</v-icon></v-btn>
      </div>
    </v-card-title>
    <v-divider class="mt-1 mb-1 mr-6 ml-6" />

    <v-card-text
      :class="{ 'date-alarm': !isMobile }"
      v-if="severetyMode || isMobile"
    >
      <div v-for="(level, key) in alarmsLevels" :key="key">
        <div class="alarm-items">
          <div class="d-flex align-center mt-2 mb-2">
            <AlarmIcon class="mr-3" :state="level.state" />
            <span class="a-title-lg a-bold"
              >{{ level.type }} ({{ level.alarms.length }})</span
            >
          </div>
        </div>
        <div
          :class="{
            'scroll-bar': !isMobile,
            'mobile-row': isMobile,
            'no-alarms': true,
          }"
          :style="defineMaxHeight"
        >
          <span class="a-text" v-if="!level.alarms.length"
            >Não há alarmes ativos</span
          >
          <LateralMobileRowAlarm class="mr-1" v-else-if="isMobile" />
          <div :class="{ 'mobile-scroll': isMobile, 'mobile-row': isMobile }">
            <div
              :class="{ snapscroll: !isMobile, 'mobile-snapscroll': isMobile }"
              v-for="(alarm, i) in level.alarms"
              :key="i"
            >
              <RowAlarm
                v-if="!isMobile"
                :item="alarm"
                @dropdownItem="handleDropdown"
              />
              <MobileRowAlarm v-else class="mr-1" :item="alarm" />
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-text v-else class="date-alarm scroll-bar">
      <RowDateAlarm
        class="snapscroll"
        v-for="(alarm, i) in historicalAlarms"
        :key="i"
        :item="alarm"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import AlarmIcon from "@/components/Icons/AlarmIcon.vue";
import RowAlarm from "./RowAlarm.vue";
import RowDateAlarm from "./RowDateAlarm.vue";
import MobileRowAlarm from "./MobileRowAlarm.vue";
import LateralMobileRowAlarm from "./LateralMobileRowAlarm.vue";
import { validateObject } from "@/models/lib.js";
import { mapGetters } from "vuex";
export default {
  name: "ModalAlarms",
  components: {
    RowAlarm,
    MobileRowAlarm,
    LateralMobileRowAlarm,
    RowDateAlarm,
    AlarmIcon,
  },
  props: {
    reference: Object,
  },
  data() {
    return {
      alarmsLevels: [
        {
          type: "Alta",
          icon: "warning",
          state: 0,
          alarms: [],
        },
        {
          type: "Média",
          icon: "error",
          state: 1,
          alarms: [],
        },
        {
          type: "Baixa",
          icon: "report",
          state: 2,
          alarms: [],
        },
      ],
      title: "Alarmes - Geral",
      severetyMode: true,
      historicalAlarms: [],
    };
  },
  watch: {
    reference: {
      handler() {
        this.handleLink();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["alarmsReceived"]),
    defineMaxHeight() {
      let height = (this.isMobile ? 385 : 540) / 3;
      return `height:${height}px`;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    handleLink() {
      this.title = "";
      let title = validateObject(this.reference, "title");
      let name = validateObject(this.reference, "name");
      if (name) {
        this.title = `Alarmes - ${this.reference.name}`;
      } else if (title) {
        this.title = `Alarmes - ${this.reference.title}`;
      }
      if (!this.title) this.title = "Alarmes - Geral";
      this.getAlarmsHistorical();
    },
    async getAlarmsHistorical() {
      let id = ["all"];
      let plantId = false;
      if (this.reference) {
        if (validateObject(this.reference, "plantsId")) {
          id = this.reference.plantsId.length ? this.reference.plantsId : id;
          plantId = false;
        } else {
          id = [this.reference.id];
          plantId = this.reference.plant ? this.reference.plant : false;
        }
      }
      this.historicalAlarms = await this.$store.dispatch("getAlarms", {
        id,
        plantId,
      });
      this.handleAlarms();
    },
    handleAlarms() {
      this.severetyMode = true;
      for (let i = 0; i < this.alarmsLevels.length; i++) {
        this.alarmsLevels[i].alarms = [];
        this.historicalAlarms.forEach((alarm) => {
          const { state } = alarm;
          if (state == this.alarmsLevels[i].state)
            this.alarmsLevels[i].alarms.push(alarm);
        });
      }
    },
    handleDropdown({ mode, id }) {
      let path = mode == "plant" ? `/plants/SOL/${id}` : `/events/${id}`;

      if (id) this.$router.push({ path });
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  max-height: 800px;
}
.alarm-items {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.rotate {
  transform: rotate(180deg);
}
.scroll-bar {
  overflow-y: scroll;
  scroll-snap-type: y proximity;
  scroll-behavior: smooth;
}

::-webkit-scrollbar-track {
  background-color: transparent !important;
}
::-webkit-scrollbar {
  width: 3px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background-color: #bdbdbd81;
}
.snapscroll {
  scroll-snap-align: start;
}
.router-link {
  display: flex;
  color: inherit;
  text-decoration: none;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 4px;
  border-radius: 5px;
}
.router-link:hover {
  background: $light;
}
.date-alarm {
  height: 715px;
}
.mobile-row {
  display: flex;
  flex-direction: row;
}
.mobile-scroll {
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100%;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
}
.mobile-snapscroll {
  scroll-snap-align: start;
}
.no-alarms {
  text-align: center;
}
</style>